import React from 'react'
import "./Checkbox.css";

function Checkbox({
    name = "",
    label = "",
    isChecked = false,
    onChange,
    fontSize = 10,
    labelStyle = null
}) {
  let id = (Math.random() * 100000)?.toString()?.split(".")[0]
  return (
    <div className='checkboxCustom'>
        <input type='checkbox' checked={isChecked} id={`${name}_${id}`} style={{background : isChecked ? "#526035" : "#FFFFFF", border : `1px solid ${isChecked ? '#526035' : 'rgba(0,0,0,0.45)'}`}} onChange={onChange} name={name} />
        <label htmlFor={`${name}_${id}`} style={{fontSize : fontSize, ...labelStyle}}>{label}</label>
        {
          isChecked && 
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              onClick={() => {
                onChange({
                  target : {
                    checked : !isChecked
                  }
                })
              }}
          >
              <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        }
    </div>
  )
}

export default Checkbox